export enum AdminBoxSaleMissingItemPickStrategy {
  FirstAvailable = 'FIRST_AVAILABLE',
  LastAvailable = 'LAST_AVAILABLE',
  MostAvailable = 'MOST_AVAILABLE',
  LeastAvailable = 'LEAST_AVAILABLE',
  HighestRemainingRatio = 'HIGHEST_REMAINING_RATIO',
  LowestRemainingRatio = 'LOWEST_REMAINING_RATIO',
  Random = 'RANDOM',
  Custom = 'CUSTOM',
}
